import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "clientName", "clientIdInput", "createLink", "workoutItem", "submitButton", "workoutIdInput", "serviceSessionIdInput"]

  connect() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("hidden")
    }
  }

  open(event) {
    if (event) event.preventDefault()
    
    // Get client data from the button's data attributes
    const clientId = event.currentTarget.dataset.clientId
    const clientName = event.currentTarget.dataset.clientName
    const serviceSessionId = event.currentTarget.dataset.serviceSessionId || ""

    // Update the UI
    this.clientNameTargets.forEach(el => el.textContent = clientName)
    this.clientIdInputTargets.forEach(el => el.value = clientId)
    this.serviceSessionIdInputTarget.value = serviceSessionId

    const createParams = new URLSearchParams({ client_id: clientId })
    if (serviceSessionId) createParams.set("service_session_id", serviceSessionId)
    this.createLinkTarget.href = `/workouts/new?${createParams.toString()}`

    // Reset selection state
    this.resetSelection()

    // Show the modal
    this.modalTarget.classList.remove("hidden")
    this.toggleScrollLock(true)
  }

  selectWorkout(event) {
    const item = event.currentTarget
    const workoutId = item.dataset.workoutId

    // Highlight the selected item
    this.workoutItemTargets.forEach(el => {
      el.classList.remove("border-blue-500", "bg-blue-50")
      el.classList.add("border-transparent", "bg-gray-50")
    })
    
    item.classList.remove("border-transparent", "bg-gray-50")
    item.classList.add("border-blue-500", "bg-blue-50")

    // Update the hidden input and enable the submit button
    this.workoutIdInputTarget.value = workoutId
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    this.submitButtonTarget.classList.add("hover:bg-blue-600")
  }

  resetSelection() {
    this.workoutItemTargets.forEach(el => {
      el.classList.remove("border-blue-500", "bg-blue-50")
      el.classList.add("border-transparent", "bg-gray-50")
    })
    this.workoutIdInputTarget.value = ""
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    this.submitButtonTarget.classList.remove("hover:bg-blue-600")
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    this.toggleScrollLock(false)
  }

  toggleScrollLock(force = null) {
    const body = document.body
    let openModals = parseInt(body.dataset.openModals || "0")

    if (force === true) {
      openModals++
    } else if (force === false) {
      openModals = Math.max(0, openModals - 1)
    }

    body.dataset.openModals = openModals

    if (openModals > 0) {
      body.classList.add("overflow-hidden")
      document.documentElement.classList.add("overflow-hidden")
    } else {
      body.classList.remove("overflow-hidden")
      document.documentElement.classList.remove("overflow-hidden")
    }
  }

  disconnect() {
    this.toggleScrollLock(false)
  }
}
